
import { Component, Vue, Ref } from "vue-property-decorator";
import { namespace } from "vuex-class";
import StepList from "@/components/scope/step-list.vue";
import { InjectFunction } from "@common/src/utils/decorator";
import t from "@common/src/i18n/t";
import ReceivePaymentDialog from "./components/receive-payment-dialog.vue";

const finance = namespace("finance");
const app = namespace("app");

@InjectFunction("dayjs", "addCurrencyUnit", "addCurrencySymbol", "emptyToLine", "splitThousands", "permit", "permitApp")
@Component({
  components: {
    StepList,
    ReceivePaymentDialog
  }
})
export default class DeferredCycleDetail extends Vue {
  @finance.Action queryDeferredPaymentDetail;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;

  @Ref("ReceivePaymentDialog") ReceivePaymentDialog;

  get breadData() {
    return [{ name: "挂账管理", path: "/finance/deferred-payment/index" }, { name: "挂账单详情" }];
  }
  detailData: any = {};
  created() {
    this.init();
  }

  get detailId() {
    return this.$route.params.id;
  }

  handleArriveStore() {
    this.$router.push(`/service/arrive/input/${this.detailId}`);
  }

  init() {
    this.queryDeferredPaymentDetail({
      onAccountNo: this.detailId
    }).then(data => {
      this.detailData = data.data;
    });
  }
  handleLinkOrderView(orderNo) {
    let { href } = this.$router.resolve({
      path: `/service/view/${orderNo}?tenantCode=${this.detailData.tenantCode || ""}`
    });
    window.open(href, "_blank");
  }
  showPrintOrder: boolean = false;
  delegatePrintObj: any = {
    id: "printMer2",
    popTitle: t("service.order-ticket"),
    extraCss: "",
    extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
  };

  searchForm = {
    onAccountNo: ""
  };
  showSumData = {
    sumDueAmount: "",
    countDue: 0
  };
  handleShowReceiveDialog() {
    this.searchForm = {
      onAccountNo: this.detailId
    };
    this.showSumData = {
      sumDueAmount: this.detailData.duePayAmount,
      countDue: 1
    };
    this.ReceivePaymentDialog.open(this.detailData.customerCode);
  }
  handleView(row) {
    let { href } = this.$router.resolve({
      path: `/service/view/${row.orderNo}`
    });
    window.open(href, "_blank");
  }
}
